export default __webpack_public_path__ + "static/media/dumperShield-Logo.13945879.png";